module.exports = __webpack_public_path__ + "img/simplexskin.11db21b2.png";